export default "__VITE_ASSET__DfFzKYGG__"